const fb = require("../firebase.js");

export default {
  namespaced: true,
  state: {
    idea: {},
    ideaPending: false,
    ideaError: null,
    ideas: [],
    ideasPending: false,
    ideasError: null,
  },
  mutations: {
    setIdea (state, value) {
      state.idea = value
    },
    createIdea (state, value) {
      state.ideas.unshift(value)
    },
    updateIdea (state, value) {
      state.ideas = state.ideas.map(el => el.id === value.id ? {...el, ...value} : el)
    },
    deleteIdea (state, id) {
      state.ideas = state.ideas.filter(function (p) {
        return p.id !== id;
      });
    },
    setIdeaPending (state, value) {
      state.ideaPending = value
    },
    setIdeaError (state, value) {
      state.ideaError = value
    },
    setIdeas (state, value) {
      state.ideas = value
    },
    setIdeasPending (state, value) {
      state.ideasPending = value
    },
    setIdeasError (state, value) {
      state.ideasError = value
    },
  },
  actions: {
    getIdeas({ state, commit }){
      if(state.ideas.length > 0) return
      commit('setIdeas', [])
      commit('setIdeasPending', true)
      fb.db.collection('ideas').orderBy("numberOfLovers", "desc").limit(10)
        .get()
        .then((querySnapshot) => {
          let ideas = []
          querySnapshot.forEach((doc) => {
            ideas.push({ id: doc.id, ...doc.data() })
          });
          commit('setIdeas', ideas)
          commit('setIdeasPending', false)
        })
        .catch((error) => {
          commit('setIdeasPending', false)
          commit('setIdeasError', error)
        })
    },
    createIdea({commit}, payload){
      let newIdea = { createdAt: fb.firebase.firestore.Timestamp.now(), ...payload }
      commit('setIdeaPending', true)
      fb.db.collection('ideas').add(newIdea).then(data =>{
          commit("createIdea", { id: data.id, ...newIdea, numberOfLovers: 1, loversId: [payload.userId]  })
          commit('setIdeaPending', false)
          fb.db.collection("ideas").doc( data.id).collection("lovers").doc(payload.userId).set({
            createdAt: fb.firebase.firestore.Timestamp.now(),
          })
        })
        .catch((error) => {
          commit('setIdeaPending', false)
          commit('setIdeaError', error)
        })
    },
    deleteIdea ({commit}, ideaId) {
      commit("deleteIdea", ideaId)
      fb.db.collection("ideas").doc(ideaId).delete()
    },
    
  }
}